// extracted by mini-css-extract-plugin
export default {"wrapper":"TextWithCount_wrapper__ZGL+7","count":"TextWithCount_count__1MHOh"};